module.exports = __webpack_public_path__ + "static/media/galenox.9c2ba5ef.jpg";